import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import loadingIcon from '../../../../Images/loading.gif'

import Formulaire from '../../../ModelesPages/Modele1/FormulaireCours_ecole'
import Swal from 'sweetalert2';
import { isEmpty } from '../../../../Utilities/Utils';
import { useAuth } from '../../../../ContextApp/AuthContext';
import './courscss.css'

function Insertion(){
    const {user}=useAuth()
    const [Count,setCount]=useState(0);
    const [loading,setLoading]=useState(false)
    const [rechercher,setRechercher]=useState(false)
    const [classes,setClasses]=useState([])
    const [cours,setCours]=useState([])
    const [enseignants,setEnseignants]=useState([])
    const [idclasseinitiale,setIdclassseinitiale]=useState("")
    const [cour,setCour]=useState("")
    const [ponderation,setPonderation]=useState("")
    const [classe,setClasse]=useState("")
    const [cours_enseign,setCours_enseign]=useState([])
    const [catdispatch,setCatdispatch]=useState("")
    const [my_enseignant,setMy_enseignant]=useState("")
    

    
    
    
    useEffect(()=>{
        HandleRequest()
        HandleRequestCours()
        HandleRequestenseignant()
        
    },[])
    useEffect(()=>{
        cours_classes()
    },[rechercher])
   
    function handleMouse(e){

        e.target.textContent="Bonjour"
    }
    function handleMouseleave(e){
        e.target.textContent="Soumettre"
    }
    function handlekeyUpgain(e){
    
        const elementss=e.nextElementSibling;
      
    }
    function handleclick(){
        alert('You have clicked me')
    }
    const HandleRequest=async()=>{
        await axios.post('api/classes_getter',{idecole:user?.ecole?.id}).then((res)=>{
            setClasses(res.data.items)
        }).catch((err)=>{
            console.log(err)
        })
    }
    const HandleRequestenseignant=async()=>{
        await axios.post('api/getenseignants',{idecole:user?.ecole?.id}).then((res)=>{
            setEnseignants(res.data.items)
        }).catch((err)=>{
            console.log(err)
        })
    }
    const HandleRequestCours=async()=>{
        await axios.get('/api/Cours').then((res)=>{
            setCours(res.data.items)
        }).catch((err)=>{
            console.log(err)
        })
    }
    function confirmSave(e){
        if(catdispatch=="classe" && !isEmpty(classe)){
            const filtre=onclickme().filter((data)=>data.renseigner==true)
                if(filtre.length>0){
                    Swal.fire({
                        title:'Demande de confirmation',
                        text:'Voulez-vous vraiment enregistrer ce cours dans cette classe ?',
                        icon:'question',
                        showCancelButton:true,
                        showConfirmButton:true,
                        confirmButtonText:'Confirmer',
                    }).then((resultat)=>{
                        if(resultat.isConfirmed){
                            HandleSubmit()
                        }
                    })  
                }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Vous devez dispatché au moins un cours de la liste à un enseignant ',
                icon:'warning'
            })
        }
    }
    else if(catdispatch=="cours" && !isEmpty(cour)){

    }
    }

    
    const HandleSubmit=async (e)=>{
       
                await axios.post('api/dispatchcour',{idclasse:Number(classe),idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,data:onclickme()}).then((res)=>{
                    setCour("")
                    setPonderation("")
                    if(res.data.status===200){
                        Swal.fire({
                            title:'Message de confirmation',
                            text:res.data.message,
                            icon:'success'
                            
                        })
                        setRechercher(!rechercher)
                    }
                    else{
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:res.data.status_message,
                            icon:'error'
                            
                        })
                    }
                     
                }).catch((err)=>{
                        document.getElementById("erreur").innerHTML=err
                        
                        
                })
    }
    const cours_classes=async()=>{
        setLoading(true)
        await axios.post("api/getcourstodispatch",{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
            setLoading(false)
            setCours_enseign(res.data.items)
        }).catch((err)=>{

        })
    }
    const recordsclasse=!isEmpty(classe) && classes.filter((clas)=>clas.id==classe)   
    const records=!isEmpty(classe) && cours_enseign.filter((cour)=>!isEmpty(cour.idclasse) ? cour.idclasse==classe && cour.idenseignant==0 : cour.idclasse_initiale==idclasseinitiale )
    const recordsexist=!isEmpty(classe) && cours_enseign.filter((cour)=>cour.idclasse==classe && cour.idenseignant!=0)
    useEffect(()=>{
        !isEmpty(classe) && setIdclassseinitiale(recordsclasse[0]["idclasse_initiale"])
        !isEmpty(classe) && console.log(idclasseinitiale)
    },[recordsclasse])
function onclickme() {
    const container = document.getElementById("dispatchnow");
    if (!container) return [];

    const selects = container.getElementsByTagName("select");
    const spans = container.getElementsByTagName("span");
    
    let my_object = [];

    for (let i = 0; i < selects.length; i++) {
        const valEnseignant = selects[i].value;
        const idCours = spans[i].id; // Récupère l'ID du span correspondant

        my_object.push({
            renseigner: valEnseignant !== "", // true si un enseignant est sélectionné
            enseignant: valEnseignant,
            cours: idCours
        });
    }

    return my_object;
}

/*function onclickme(){
   let my_object=[]
    const allselect=document.getElementById("dispatchnow").getElementsByTagName("select").length
    for(let i=0;i<allselect;i++){
        let etat=!isEmpty(document.getElementById("dispatchnow").getElementsByTagName("select")[i].value) ? true : false
        my_object=[
            ...my_object,
            {
                renseigner:etat,
                enseignant:document.getElementById("dispatchnow").getElementsByTagName("select")[i].value,
                cours:document.getElementById("dispatchnow").getElementsByTagName("span")[i].id,

            }
        ]
    }
   console.log(allselect)
    
    return my_object
  }*/
  const Affichage = () => {
    if (!isEmpty(classe) && catdispatch === "classe") {
        return loading ? (
            <div className='text-center py-4'>
                <div className="spinner-border text-primary" role="status"></div>
                <p className="mt-2 text-muted">Chargement des cours...</p>
            </div>
        ) : (
            records.length > 0 && (
                <div id="dispatchnow"> {/* Ajout de l'ID ici */}
    <div className="list-group list-group-flush rounded-3 border">
        {records.map((cour, indexV) => (
            <div key={cour.id} className="list-group-item p-3">
                <div className="row align-items-center">
                    <div className="col-md-5">
                        <label className="fw-bold text-dark">
                            <i className="bi bi-book-half me-2 text-primary"></i>
                            {/* Le span qui contient l'ID du cours */}
                            <span id={cour.id}>{cour.cours}</span>
                        </label>
                    </div>
                    <div className="col-md-7">
                        <select className="form-select">
                            <option value="" disabled selected>Choix de l'enseignant</option>
                            {enseignants.map((ense) => (
                                <option value={ense.my_enseignant} key={ense.id}>
                                    {ense.nom_complet}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        ))}
    </div>
</div>

            )
        );
    }
};
const Iteration = () => {
    return loading ? (
        <div className='text-center py-4'>
            <div className="spinner-border text-secondary" role="status"></div>
        </div>
    ) : (
        recordsexist.length > 0 && (
            <div className="row g-3">
                {recordsexist.map((cour, indexV) => (
                    <div className="col-12" key={indexV}>
                        <div className="d-flex align-items-center p-3 rounded-3 border border-start-4 border-start-primary bg-white shadow-sm transition-all hover-shadow">
                            <div className="flex-shrink-0 me-3">
                                <div className="avatar-sm bg-primary-subtle text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold">
                                    {indexV + 1}
                                </div>
                            </div>
                            <div className="flex-grow-1">
                                <h6 className="mb-0 fw-bold text-capitalize text-dark">{cour.cours}</h6>
                                <small className="text-muted text-capitalize">
                                    <i className="bi bi-person me-1"></i>
                                    {cour.enseignant}
                                </small>
                            </div>
                            <div className="ms-auto">
                                <button className="btn btn-sm btn-outline-light text-muted border-0">
                                    <i className="bi bi-three-dots-vertical"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    );
};


      return(
    <>
    <Formulaire title="Formulaire de gestion des cours" recordsexist={recordsexist} Affichage={Affichage} my_enseignant={my_enseignant} setMy_enseignant={setMy_enseignant} enseignants={enseignants} setEnseignants={setEnseignants} titlecours="Liste des cours déjà dispatchés" setCatdispatch={setCatdispatch} catdispatch={catdispatch} onclick={handleclick}   confirmSave={confirmSave} setClasse={setClasse} handlekeyUpgain={handlekeyUpgain}  classe={classe}  handleMouse={handleMouse} Count={Count} setCount={setCount} handleMouseleave={handleMouseleave} HandleSubmit={HandleSubmit} ponderation={ponderation} setPonderation={setPonderation} cour={cour} setCour={setCour} cours={cours}  classes={classes} >
       <div className="">
            {Iteration()}
       </div>
    </Formulaire>
    </>
    )
}
export default Insertion